import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

let _devB64 = null;
async function loadDevanagari() {
  if (_devB64) return _devB64;
  const resp = await fetch("/fonts/NotoSansDevanagari-Regular.ttf");
  const buf = await resp.arrayBuffer();
  const bytes = new Uint8Array(buf);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  _devB64 = btoa(binary);
  return _devB64;
}

export async function exportPDF({ title, columns, rows, filename, subtitle, lang }) {
  const doc = new jsPDF();
  let font = "helvetica";
  if (lang === "mr") {
    try {
      const b64 = await loadDevanagari();
      doc.addFileToVFS("NotoSansDevanagari.ttf", b64);
      doc.addFont("NotoSansDevanagari.ttf", "NotoDev", "normal");
      font = "NotoDev";
    } catch (e) {
      font = "helvetica";
    }
  }
  doc.setFont(font);
  doc.setFontSize(16);
  doc.text(title, 14, 16);
  if (subtitle) {
    doc.setFontSize(10);
    doc.setTextColor(120);
    doc.text(subtitle, 14, 22);
  }
  autoTable(doc, {
    startY: subtitle ? 27 : 22,
    head: [columns.map((c) => c.header)],
    body: rows.map((r) => columns.map((c) => String(r[c.key] ?? ""))),
    styles: { fontSize: 8, cellPadding: 2, font },
    headStyles: { fillColor: [58, 90, 64], font, textColor: [255, 255, 255] },
  });
  doc.save(`${filename}.pdf`);
}

export function exportExcel({ columns, rows, filename, sheet = "Sheet1" }) {
  const data = rows.map((r) => {
    const o = {};
    columns.forEach((c) => (o[c.header] = r[c.key] ?? ""));
    return o;
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheet);
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function printThermalReceipt() {
  window.print();
}
